import styled, { css } from 'styled-components';
import { Dropdown, Menu } from 'antd';

export const DropdownContainer = styled.div<{disabled?:boolean, highlight?:boolean}>`
	flex-basis: 100%;
	position: relative;
	display: block;
	margin: 3px;
	height: 50px;
	border: 1px solid ${(props) => props.theme.colors.darkGray};
	box-sizing: border-box;

	${(props) => props.highlight && css`
		border-color: ${props.theme.colors.red};
		animation: blink 1s linear 1.6;
		
		/* Safari 4.0 - 8.0 */
		@-webkit-keyframes blink {
			50% {
				opacity: 0;
			}
		}
		
		/* Standard syntax */
		@keyframes blink {
			50% {
				opacity: 0;
			}
		}
	`}
`;

export const StyledDropdown = styled(Dropdown)<{disabled?:boolean}>`
	cursor: pointer;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0px 12px;
	box-sizing: border-box;

	& .svg-wrapper {
		svg {
			transition: transform 0.1s !important;
		};
	};

	&.ant-dropdown-open {
		svg {
			transform: rotateZ(90deg) !important;
		};
	};

	${(props) => props.disabled && css`
		cursor: unset;
		& .svg-wrapper {
			display: none;
		}
	`};
`;

export const StyledMenu = styled(Menu)`
	border-radius: 5px;
	box-shadow: -5px 5px 10px rgba(0, 0, 0, 0.15);
	overflow-y: auto;
	max-height: 400px;
`;

export const SelectedOption = styled.div`
	position: relative;
	width: 100%;
	vertical-align: middle;

	&& svg {
		position: absolute;
		right: 18px;
		bottom: 14px;
		transition: transform 3s;
		transform: rotateZ(270deg);
		vertical-align: middle;
	}
`;

export const StyledMenuItem = styled(Menu.Item)<{isSelected:boolean}>`
	position: relative;

	${(props) => props.isSelected && css`
		font-weight: bold;
	`};

	&:hover {
    background-color: inherit;
  }
`;